/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as ProtectedRouteRouteImport } from './routes/_protected/route'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthSignInRouteImport } from './routes/_auth/sign-in'
import { Route as ProtectedAccountRouteRouteImport } from './routes/_protected/account/route'
import { Route as ProtectedCarriersRouteRouteImport } from './routes/_protected/carriers/route'
import { Route as ProtectedDocumentReaderRouteRouteImport } from './routes/_protected/document-reader/route'
import { Route as ProtectedInsightsRouteImport } from './routes/_protected/insights'
import { Route as ProtectedInvoicesRouteImport } from './routes/_protected/invoices'
import { Route as ProtectedSearchRouteImport } from './routes/_protected/search'
import { Route as ProtectedShipmentsRouteRouteImport } from './routes/_protected/shipments/route'
import { Route as ProtectedAccountIndexRouteImport } from './routes/_protected/account/index'
import { Route as ProtectedAccountNotificationsRouteImport } from './routes/_protected/account/notifications'
import { Route as ProtectedCalculatorSubscriptionsRouteImport } from './routes/_protected/calculator/subscriptions'
import { Route as ProtectedCalculatorChar123UuidChar125RouteImport } from './routes/_protected/calculator/{-$uuid}'
import { Route as ProtectedCarriersIndexRouteImport } from './routes/_protected/carriers/index'
import { Route as ProtectedCarriersAddRouteImport } from './routes/_protected/carriers/add'
import { Route as ProtectedDocumentReaderIndexRouteImport } from './routes/_protected/document-reader/index'
import { Route as ProtectedDocumentReaderSubmissionIdRouteImport } from './routes/_protected/document-reader/$submissionId'
import { Route as ProtectedLanesIndexRouteImport } from './routes/_protected/lanes/index'
import { Route as ProtectedLanesLaneIdRouteImport } from './routes/_protected/lanes/$laneId'
import { Route as ProtectedLanesCreateRouteImport } from './routes/_protected/lanes/create'
import { Route as ProtectedShipmentsShipmentNumberRouteImport } from './routes/_protected/shipments/$shipmentNumber'
import { Route as ProtectedShipmentsoverviewRouteRouteImport } from './routes/_protected/shipments/(overview)/route'
import { Route as PublicPriceCalculatorChar123UuidChar125RouteImport } from './routes/_public/price-calculator/{-$uuid}'
import { Route as ProtectedOrgOrgIdSettingsRouteRouteImport } from './routes/_protected/org/$orgId/settings/route'
import { Route as ProtectedShipmentsoverviewIndexRouteImport } from './routes/_protected/shipments/(overview)/index'
import { Route as ProtectedShipmentsoverviewArchivedRouteImport } from './routes/_protected/shipments/(overview)/archived'
import { Route as ProtectedShipmentsoverviewAssignedRouteImport } from './routes/_protected/shipments/(overview)/assigned'
import { Route as ProtectedShipmentsoverviewDraftedRouteImport } from './routes/_protected/shipments/(overview)/drafted'
import { Route as ProtectedShipmentsoverviewGroupsRouteImport } from './routes/_protected/shipments/(overview)/groups'
import { Route as ProtectedShipmentsAddIndexRouteImport } from './routes/_protected/shipments/add/index'
import { Route as ProtectedShipmentsAddBulkRouteImport } from './routes/_protected/shipments/add/bulk'
import { Route as ProtectedShipmentsAddManualRouteImport } from './routes/_protected/shipments/add/manual'
import { Route as ProtectedShipmentsGroupsGroupIdRouteRouteImport } from './routes/_protected/shipments/groups/$groupId/route'
import { Route as ProtectedOrgOrgIdSettingsIndexRouteImport } from './routes/_protected/org/$orgId/settings/index'
import { Route as ProtectedOrgOrgIdSettingsBillingRouteImport } from './routes/_protected/org/$orgId/settings/billing'
import { Route as ProtectedOrgOrgIdSettingsBlacklistedCarriersRouteImport } from './routes/_protected/org/$orgId/settings/blacklisted-carriers'
import { Route as ProtectedOrgOrgIdSettingsDocumentsRouteRouteImport } from './routes/_protected/org/$orgId/settings/documents/route'
import { Route as ProtectedOrgOrgIdSettingsShipmentSettingsRouteImport } from './routes/_protected/org/$orgId/settings/shipment-settings'
import { Route as ProtectedOrgOrgIdSettingsSubscriptionsRouteImport } from './routes/_protected/org/$orgId/settings/subscriptions'
import { Route as ProtectedOrgOrgIdSettingsUsersRouteRouteImport } from './routes/_protected/org/$orgId/settings/users/route'
import { Route as ProtectedShipmentsGroupsGroupIdIndexRouteImport } from './routes/_protected/shipments/groups/$groupId/index'
import { Route as ProtectedShipmentsGroupsGroupIdArchivedRouteImport } from './routes/_protected/shipments/groups/$groupId/archived'
import { Route as ProtectedShipmentsGroupsGroupIdAssignedRouteImport } from './routes/_protected/shipments/groups/$groupId/assigned'
import { Route as ProtectedShipmentsGroupsGroupIdDraftedRouteImport } from './routes/_protected/shipments/groups/$groupId/drafted'
import { Route as ProtectedOrgOrgIdSettingsDocumentsIndexRouteImport } from './routes/_protected/org/$orgId/settings/documents/index'
import { Route as ProtectedOrgOrgIdSettingsUsersIndexRouteImport } from './routes/_protected/org/$orgId/settings/users/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedRouteRoute = ProtectedRouteRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRouteRoute,
} as any)
const ProtectedAccountRouteRoute = ProtectedAccountRouteRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedCarriersRouteRoute = ProtectedCarriersRouteRouteImport.update({
  id: '/carriers',
  path: '/carriers',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedDocumentReaderRouteRoute =
  ProtectedDocumentReaderRouteRouteImport.update({
    id: '/document-reader',
    path: '/document-reader',
    getParentRoute: () => ProtectedRouteRoute,
  } as any)
const ProtectedInsightsRoute = ProtectedInsightsRouteImport.update({
  id: '/insights',
  path: '/insights',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedInvoicesRoute = ProtectedInvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedSearchRoute = ProtectedSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedShipmentsRouteRoute = ProtectedShipmentsRouteRouteImport.update({
  id: '/shipments',
  path: '/shipments',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedAccountIndexRoute = ProtectedAccountIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedAccountRouteRoute,
} as any)
const ProtectedAccountNotificationsRoute =
  ProtectedAccountNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => ProtectedAccountRouteRoute,
  } as any)
const ProtectedCalculatorSubscriptionsRoute =
  ProtectedCalculatorSubscriptionsRouteImport.update({
    id: '/calculator/subscriptions',
    path: '/calculator/subscriptions',
    getParentRoute: () => ProtectedRouteRoute,
  } as any)
const ProtectedCalculatorChar123UuidChar125Route =
  ProtectedCalculatorChar123UuidChar125RouteImport.update({
    id: '/calculator/{-$uuid}',
    path: '/calculator/{-$uuid}',
    getParentRoute: () => ProtectedRouteRoute,
  } as any)
const ProtectedCarriersIndexRoute = ProtectedCarriersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedCarriersRouteRoute,
} as any)
const ProtectedCarriersAddRoute = ProtectedCarriersAddRouteImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => ProtectedCarriersRouteRoute,
} as any)
const ProtectedDocumentReaderIndexRoute =
  ProtectedDocumentReaderIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedDocumentReaderRouteRoute,
  } as any)
const ProtectedDocumentReaderSubmissionIdRoute =
  ProtectedDocumentReaderSubmissionIdRouteImport.update({
    id: '/$submissionId',
    path: '/$submissionId',
    getParentRoute: () => ProtectedDocumentReaderRouteRoute,
  } as any)
const ProtectedLanesIndexRoute = ProtectedLanesIndexRouteImport.update({
  id: '/lanes/',
  path: '/lanes/',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedLanesLaneIdRoute = ProtectedLanesLaneIdRouteImport.update({
  id: '/lanes/$laneId',
  path: '/lanes/$laneId',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedLanesCreateRoute = ProtectedLanesCreateRouteImport.update({
  id: '/lanes/create',
  path: '/lanes/create',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedShipmentsShipmentNumberRoute =
  ProtectedShipmentsShipmentNumberRouteImport.update({
    id: '/$shipmentNumber',
    path: '/$shipmentNumber',
    getParentRoute: () => ProtectedShipmentsRouteRoute,
  } as any)
const ProtectedShipmentsoverviewRouteRoute =
  ProtectedShipmentsoverviewRouteRouteImport.update({
    id: '/(overview)',
    getParentRoute: () => ProtectedShipmentsRouteRoute,
  } as any)
const PublicPriceCalculatorChar123UuidChar125Route =
  PublicPriceCalculatorChar123UuidChar125RouteImport.update({
    id: '/_public/price-calculator/{-$uuid}',
    path: '/price-calculator/{-$uuid}',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProtectedOrgOrgIdSettingsRouteRoute =
  ProtectedOrgOrgIdSettingsRouteRouteImport.update({
    id: '/org/$orgId/settings',
    path: '/org/$orgId/settings',
    getParentRoute: () => ProtectedRouteRoute,
  } as any)
const ProtectedShipmentsoverviewIndexRoute =
  ProtectedShipmentsoverviewIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedShipmentsoverviewRouteRoute,
  } as any)
const ProtectedShipmentsoverviewArchivedRoute =
  ProtectedShipmentsoverviewArchivedRouteImport.update({
    id: '/archived',
    path: '/archived',
    getParentRoute: () => ProtectedShipmentsoverviewRouteRoute,
  } as any)
const ProtectedShipmentsoverviewAssignedRoute =
  ProtectedShipmentsoverviewAssignedRouteImport.update({
    id: '/assigned',
    path: '/assigned',
    getParentRoute: () => ProtectedShipmentsoverviewRouteRoute,
  } as any)
const ProtectedShipmentsoverviewDraftedRoute =
  ProtectedShipmentsoverviewDraftedRouteImport.update({
    id: '/drafted',
    path: '/drafted',
    getParentRoute: () => ProtectedShipmentsoverviewRouteRoute,
  } as any)
const ProtectedShipmentsoverviewGroupsRoute =
  ProtectedShipmentsoverviewGroupsRouteImport.update({
    id: '/groups',
    path: '/groups',
    getParentRoute: () => ProtectedShipmentsoverviewRouteRoute,
  } as any)
const ProtectedShipmentsAddIndexRoute =
  ProtectedShipmentsAddIndexRouteImport.update({
    id: '/add/',
    path: '/add/',
    getParentRoute: () => ProtectedShipmentsRouteRoute,
  } as any)
const ProtectedShipmentsAddBulkRoute =
  ProtectedShipmentsAddBulkRouteImport.update({
    id: '/add/bulk',
    path: '/add/bulk',
    getParentRoute: () => ProtectedShipmentsRouteRoute,
  } as any)
const ProtectedShipmentsAddManualRoute =
  ProtectedShipmentsAddManualRouteImport.update({
    id: '/add/manual',
    path: '/add/manual',
    getParentRoute: () => ProtectedShipmentsRouteRoute,
  } as any)
const ProtectedShipmentsGroupsGroupIdRouteRoute =
  ProtectedShipmentsGroupsGroupIdRouteRouteImport.update({
    id: '/groups/$groupId',
    path: '/groups/$groupId',
    getParentRoute: () => ProtectedShipmentsRouteRoute,
  } as any)
const ProtectedOrgOrgIdSettingsIndexRoute =
  ProtectedOrgOrgIdSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedOrgOrgIdSettingsRouteRoute,
  } as any)
const ProtectedOrgOrgIdSettingsBillingRoute =
  ProtectedOrgOrgIdSettingsBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => ProtectedOrgOrgIdSettingsRouteRoute,
  } as any)
const ProtectedOrgOrgIdSettingsBlacklistedCarriersRoute =
  ProtectedOrgOrgIdSettingsBlacklistedCarriersRouteImport.update({
    id: '/blacklisted-carriers',
    path: '/blacklisted-carriers',
    getParentRoute: () => ProtectedOrgOrgIdSettingsRouteRoute,
  } as any)
const ProtectedOrgOrgIdSettingsDocumentsRouteRoute =
  ProtectedOrgOrgIdSettingsDocumentsRouteRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => ProtectedOrgOrgIdSettingsRouteRoute,
  } as any)
const ProtectedOrgOrgIdSettingsShipmentSettingsRoute =
  ProtectedOrgOrgIdSettingsShipmentSettingsRouteImport.update({
    id: '/shipment-settings',
    path: '/shipment-settings',
    getParentRoute: () => ProtectedOrgOrgIdSettingsRouteRoute,
  } as any)
const ProtectedOrgOrgIdSettingsSubscriptionsRoute =
  ProtectedOrgOrgIdSettingsSubscriptionsRouteImport.update({
    id: '/subscriptions',
    path: '/subscriptions',
    getParentRoute: () => ProtectedOrgOrgIdSettingsRouteRoute,
  } as any)
const ProtectedOrgOrgIdSettingsUsersRouteRoute =
  ProtectedOrgOrgIdSettingsUsersRouteRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => ProtectedOrgOrgIdSettingsRouteRoute,
  } as any)
const ProtectedShipmentsGroupsGroupIdIndexRoute =
  ProtectedShipmentsGroupsGroupIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedShipmentsGroupsGroupIdRouteRoute,
  } as any)
const ProtectedShipmentsGroupsGroupIdArchivedRoute =
  ProtectedShipmentsGroupsGroupIdArchivedRouteImport.update({
    id: '/archived',
    path: '/archived',
    getParentRoute: () => ProtectedShipmentsGroupsGroupIdRouteRoute,
  } as any)
const ProtectedShipmentsGroupsGroupIdAssignedRoute =
  ProtectedShipmentsGroupsGroupIdAssignedRouteImport.update({
    id: '/assigned',
    path: '/assigned',
    getParentRoute: () => ProtectedShipmentsGroupsGroupIdRouteRoute,
  } as any)
const ProtectedShipmentsGroupsGroupIdDraftedRoute =
  ProtectedShipmentsGroupsGroupIdDraftedRouteImport.update({
    id: '/drafted',
    path: '/drafted',
    getParentRoute: () => ProtectedShipmentsGroupsGroupIdRouteRoute,
  } as any)
const ProtectedOrgOrgIdSettingsDocumentsIndexRoute =
  ProtectedOrgOrgIdSettingsDocumentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedOrgOrgIdSettingsDocumentsRouteRoute,
  } as any)
const ProtectedOrgOrgIdSettingsUsersIndexRoute =
  ProtectedOrgOrgIdSettingsUsersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedOrgOrgIdSettingsUsersRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account': typeof ProtectedAccountRouteRouteWithChildren
  '/carriers': typeof ProtectedCarriersRouteRouteWithChildren
  '/document-reader': typeof ProtectedDocumentReaderRouteRouteWithChildren
  '/shipments': typeof ProtectedShipmentsoverviewRouteRouteWithChildren
  '/reset-password': typeof AuthResetPasswordRoute
  '/sign-in': typeof AuthSignInRoute
  '/insights': typeof ProtectedInsightsRoute
  '/invoices': typeof ProtectedInvoicesRoute
  '/search': typeof ProtectedSearchRoute
  '/account/notifications': typeof ProtectedAccountNotificationsRoute
  '/calculator/subscriptions': typeof ProtectedCalculatorSubscriptionsRoute
  '/calculator/{-$uuid}': typeof ProtectedCalculatorChar123UuidChar125Route
  '/carriers/add': typeof ProtectedCarriersAddRoute
  '/document-reader/$submissionId': typeof ProtectedDocumentReaderSubmissionIdRoute
  '/lanes/$laneId': typeof ProtectedLanesLaneIdRoute
  '/lanes/create': typeof ProtectedLanesCreateRoute
  '/shipments/$shipmentNumber': typeof ProtectedShipmentsShipmentNumberRoute
  '/price-calculator/{-$uuid}': typeof PublicPriceCalculatorChar123UuidChar125Route
  '/account/': typeof ProtectedAccountIndexRoute
  '/carriers/': typeof ProtectedCarriersIndexRoute
  '/document-reader/': typeof ProtectedDocumentReaderIndexRoute
  '/lanes/': typeof ProtectedLanesIndexRoute
  '/org/$orgId/settings': typeof ProtectedOrgOrgIdSettingsRouteRouteWithChildren
  '/shipments/groups/$groupId': typeof ProtectedShipmentsGroupsGroupIdRouteRouteWithChildren
  '/shipments/archived': typeof ProtectedShipmentsoverviewArchivedRoute
  '/shipments/assigned': typeof ProtectedShipmentsoverviewAssignedRoute
  '/shipments/drafted': typeof ProtectedShipmentsoverviewDraftedRoute
  '/shipments/groups': typeof ProtectedShipmentsoverviewGroupsRoute
  '/shipments/add/bulk': typeof ProtectedShipmentsAddBulkRoute
  '/shipments/add/manual': typeof ProtectedShipmentsAddManualRoute
  '/shipments/': typeof ProtectedShipmentsoverviewIndexRoute
  '/shipments/add/': typeof ProtectedShipmentsAddIndexRoute
  '/org/$orgId/settings/documents': typeof ProtectedOrgOrgIdSettingsDocumentsRouteRouteWithChildren
  '/org/$orgId/settings/users': typeof ProtectedOrgOrgIdSettingsUsersRouteRouteWithChildren
  '/org/$orgId/settings/billing': typeof ProtectedOrgOrgIdSettingsBillingRoute
  '/org/$orgId/settings/blacklisted-carriers': typeof ProtectedOrgOrgIdSettingsBlacklistedCarriersRoute
  '/org/$orgId/settings/shipment-settings': typeof ProtectedOrgOrgIdSettingsShipmentSettingsRoute
  '/org/$orgId/settings/subscriptions': typeof ProtectedOrgOrgIdSettingsSubscriptionsRoute
  '/shipments/groups/$groupId/archived': typeof ProtectedShipmentsGroupsGroupIdArchivedRoute
  '/shipments/groups/$groupId/assigned': typeof ProtectedShipmentsGroupsGroupIdAssignedRoute
  '/shipments/groups/$groupId/drafted': typeof ProtectedShipmentsGroupsGroupIdDraftedRoute
  '/org/$orgId/settings/': typeof ProtectedOrgOrgIdSettingsIndexRoute
  '/shipments/groups/$groupId/': typeof ProtectedShipmentsGroupsGroupIdIndexRoute
  '/org/$orgId/settings/documents/': typeof ProtectedOrgOrgIdSettingsDocumentsIndexRoute
  '/org/$orgId/settings/users/': typeof ProtectedOrgOrgIdSettingsUsersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/shipments': typeof ProtectedShipmentsoverviewIndexRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/sign-in': typeof AuthSignInRoute
  '/insights': typeof ProtectedInsightsRoute
  '/invoices': typeof ProtectedInvoicesRoute
  '/search': typeof ProtectedSearchRoute
  '/account/notifications': typeof ProtectedAccountNotificationsRoute
  '/calculator/subscriptions': typeof ProtectedCalculatorSubscriptionsRoute
  '/calculator/{-$uuid}': typeof ProtectedCalculatorChar123UuidChar125Route
  '/carriers/add': typeof ProtectedCarriersAddRoute
  '/document-reader/$submissionId': typeof ProtectedDocumentReaderSubmissionIdRoute
  '/lanes/$laneId': typeof ProtectedLanesLaneIdRoute
  '/lanes/create': typeof ProtectedLanesCreateRoute
  '/shipments/$shipmentNumber': typeof ProtectedShipmentsShipmentNumberRoute
  '/price-calculator/{-$uuid}': typeof PublicPriceCalculatorChar123UuidChar125Route
  '/account': typeof ProtectedAccountIndexRoute
  '/carriers': typeof ProtectedCarriersIndexRoute
  '/document-reader': typeof ProtectedDocumentReaderIndexRoute
  '/lanes': typeof ProtectedLanesIndexRoute
  '/shipments/archived': typeof ProtectedShipmentsoverviewArchivedRoute
  '/shipments/assigned': typeof ProtectedShipmentsoverviewAssignedRoute
  '/shipments/drafted': typeof ProtectedShipmentsoverviewDraftedRoute
  '/shipments/groups': typeof ProtectedShipmentsoverviewGroupsRoute
  '/shipments/add/bulk': typeof ProtectedShipmentsAddBulkRoute
  '/shipments/add/manual': typeof ProtectedShipmentsAddManualRoute
  '/shipments/add': typeof ProtectedShipmentsAddIndexRoute
  '/org/$orgId/settings/billing': typeof ProtectedOrgOrgIdSettingsBillingRoute
  '/org/$orgId/settings/blacklisted-carriers': typeof ProtectedOrgOrgIdSettingsBlacklistedCarriersRoute
  '/org/$orgId/settings/shipment-settings': typeof ProtectedOrgOrgIdSettingsShipmentSettingsRoute
  '/org/$orgId/settings/subscriptions': typeof ProtectedOrgOrgIdSettingsSubscriptionsRoute
  '/shipments/groups/$groupId/archived': typeof ProtectedShipmentsGroupsGroupIdArchivedRoute
  '/shipments/groups/$groupId/assigned': typeof ProtectedShipmentsGroupsGroupIdAssignedRoute
  '/shipments/groups/$groupId/drafted': typeof ProtectedShipmentsGroupsGroupIdDraftedRoute
  '/org/$orgId/settings': typeof ProtectedOrgOrgIdSettingsIndexRoute
  '/shipments/groups/$groupId': typeof ProtectedShipmentsGroupsGroupIdIndexRoute
  '/org/$orgId/settings/documents': typeof ProtectedOrgOrgIdSettingsDocumentsIndexRoute
  '/org/$orgId/settings/users': typeof ProtectedOrgOrgIdSettingsUsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteRouteWithChildren
  '/_protected': typeof ProtectedRouteRouteWithChildren
  '/_protected/account': typeof ProtectedAccountRouteRouteWithChildren
  '/_protected/carriers': typeof ProtectedCarriersRouteRouteWithChildren
  '/_protected/document-reader': typeof ProtectedDocumentReaderRouteRouteWithChildren
  '/_protected/shipments': typeof ProtectedShipmentsRouteRouteWithChildren
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_auth/sign-in': typeof AuthSignInRoute
  '/_protected/insights': typeof ProtectedInsightsRoute
  '/_protected/invoices': typeof ProtectedInvoicesRoute
  '/_protected/search': typeof ProtectedSearchRoute
  '/_protected/shipments/(overview)': typeof ProtectedShipmentsoverviewRouteRouteWithChildren
  '/_protected/account/notifications': typeof ProtectedAccountNotificationsRoute
  '/_protected/calculator/subscriptions': typeof ProtectedCalculatorSubscriptionsRoute
  '/_protected/calculator/{-$uuid}': typeof ProtectedCalculatorChar123UuidChar125Route
  '/_protected/carriers/add': typeof ProtectedCarriersAddRoute
  '/_protected/document-reader/$submissionId': typeof ProtectedDocumentReaderSubmissionIdRoute
  '/_protected/lanes/$laneId': typeof ProtectedLanesLaneIdRoute
  '/_protected/lanes/create': typeof ProtectedLanesCreateRoute
  '/_protected/shipments/$shipmentNumber': typeof ProtectedShipmentsShipmentNumberRoute
  '/_public/price-calculator/{-$uuid}': typeof PublicPriceCalculatorChar123UuidChar125Route
  '/_protected/account/': typeof ProtectedAccountIndexRoute
  '/_protected/carriers/': typeof ProtectedCarriersIndexRoute
  '/_protected/document-reader/': typeof ProtectedDocumentReaderIndexRoute
  '/_protected/lanes/': typeof ProtectedLanesIndexRoute
  '/_protected/org/$orgId/settings': typeof ProtectedOrgOrgIdSettingsRouteRouteWithChildren
  '/_protected/shipments/groups/$groupId': typeof ProtectedShipmentsGroupsGroupIdRouteRouteWithChildren
  '/_protected/shipments/(overview)/archived': typeof ProtectedShipmentsoverviewArchivedRoute
  '/_protected/shipments/(overview)/assigned': typeof ProtectedShipmentsoverviewAssignedRoute
  '/_protected/shipments/(overview)/drafted': typeof ProtectedShipmentsoverviewDraftedRoute
  '/_protected/shipments/(overview)/groups': typeof ProtectedShipmentsoverviewGroupsRoute
  '/_protected/shipments/add/bulk': typeof ProtectedShipmentsAddBulkRoute
  '/_protected/shipments/add/manual': typeof ProtectedShipmentsAddManualRoute
  '/_protected/shipments/(overview)/': typeof ProtectedShipmentsoverviewIndexRoute
  '/_protected/shipments/add/': typeof ProtectedShipmentsAddIndexRoute
  '/_protected/org/$orgId/settings/documents': typeof ProtectedOrgOrgIdSettingsDocumentsRouteRouteWithChildren
  '/_protected/org/$orgId/settings/users': typeof ProtectedOrgOrgIdSettingsUsersRouteRouteWithChildren
  '/_protected/org/$orgId/settings/billing': typeof ProtectedOrgOrgIdSettingsBillingRoute
  '/_protected/org/$orgId/settings/blacklisted-carriers': typeof ProtectedOrgOrgIdSettingsBlacklistedCarriersRoute
  '/_protected/org/$orgId/settings/shipment-settings': typeof ProtectedOrgOrgIdSettingsShipmentSettingsRoute
  '/_protected/org/$orgId/settings/subscriptions': typeof ProtectedOrgOrgIdSettingsSubscriptionsRoute
  '/_protected/shipments/groups/$groupId/archived': typeof ProtectedShipmentsGroupsGroupIdArchivedRoute
  '/_protected/shipments/groups/$groupId/assigned': typeof ProtectedShipmentsGroupsGroupIdAssignedRoute
  '/_protected/shipments/groups/$groupId/drafted': typeof ProtectedShipmentsGroupsGroupIdDraftedRoute
  '/_protected/org/$orgId/settings/': typeof ProtectedOrgOrgIdSettingsIndexRoute
  '/_protected/shipments/groups/$groupId/': typeof ProtectedShipmentsGroupsGroupIdIndexRoute
  '/_protected/org/$orgId/settings/documents/': typeof ProtectedOrgOrgIdSettingsDocumentsIndexRoute
  '/_protected/org/$orgId/settings/users/': typeof ProtectedOrgOrgIdSettingsUsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/carriers'
    | '/document-reader'
    | '/shipments'
    | '/reset-password'
    | '/sign-in'
    | '/insights'
    | '/invoices'
    | '/search'
    | '/account/notifications'
    | '/calculator/subscriptions'
    | '/calculator/{-$uuid}'
    | '/carriers/add'
    | '/document-reader/$submissionId'
    | '/lanes/$laneId'
    | '/lanes/create'
    | '/shipments/$shipmentNumber'
    | '/price-calculator/{-$uuid}'
    | '/account/'
    | '/carriers/'
    | '/document-reader/'
    | '/lanes/'
    | '/org/$orgId/settings'
    | '/shipments/groups/$groupId'
    | '/shipments/archived'
    | '/shipments/assigned'
    | '/shipments/drafted'
    | '/shipments/groups'
    | '/shipments/add/bulk'
    | '/shipments/add/manual'
    | '/shipments/'
    | '/shipments/add/'
    | '/org/$orgId/settings/documents'
    | '/org/$orgId/settings/users'
    | '/org/$orgId/settings/billing'
    | '/org/$orgId/settings/blacklisted-carriers'
    | '/org/$orgId/settings/shipment-settings'
    | '/org/$orgId/settings/subscriptions'
    | '/shipments/groups/$groupId/archived'
    | '/shipments/groups/$groupId/assigned'
    | '/shipments/groups/$groupId/drafted'
    | '/org/$orgId/settings/'
    | '/shipments/groups/$groupId/'
    | '/org/$orgId/settings/documents/'
    | '/org/$orgId/settings/users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/shipments'
    | '/reset-password'
    | '/sign-in'
    | '/insights'
    | '/invoices'
    | '/search'
    | '/account/notifications'
    | '/calculator/subscriptions'
    | '/calculator/{-$uuid}'
    | '/carriers/add'
    | '/document-reader/$submissionId'
    | '/lanes/$laneId'
    | '/lanes/create'
    | '/shipments/$shipmentNumber'
    | '/price-calculator/{-$uuid}'
    | '/account'
    | '/carriers'
    | '/document-reader'
    | '/lanes'
    | '/shipments/archived'
    | '/shipments/assigned'
    | '/shipments/drafted'
    | '/shipments/groups'
    | '/shipments/add/bulk'
    | '/shipments/add/manual'
    | '/shipments/add'
    | '/org/$orgId/settings/billing'
    | '/org/$orgId/settings/blacklisted-carriers'
    | '/org/$orgId/settings/shipment-settings'
    | '/org/$orgId/settings/subscriptions'
    | '/shipments/groups/$groupId/archived'
    | '/shipments/groups/$groupId/assigned'
    | '/shipments/groups/$groupId/drafted'
    | '/org/$orgId/settings'
    | '/shipments/groups/$groupId'
    | '/org/$orgId/settings/documents'
    | '/org/$orgId/settings/users'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_protected'
    | '/_protected/account'
    | '/_protected/carriers'
    | '/_protected/document-reader'
    | '/_protected/shipments'
    | '/_auth/reset-password'
    | '/_auth/sign-in'
    | '/_protected/insights'
    | '/_protected/invoices'
    | '/_protected/search'
    | '/_protected/shipments/(overview)'
    | '/_protected/account/notifications'
    | '/_protected/calculator/subscriptions'
    | '/_protected/calculator/{-$uuid}'
    | '/_protected/carriers/add'
    | '/_protected/document-reader/$submissionId'
    | '/_protected/lanes/$laneId'
    | '/_protected/lanes/create'
    | '/_protected/shipments/$shipmentNumber'
    | '/_public/price-calculator/{-$uuid}'
    | '/_protected/account/'
    | '/_protected/carriers/'
    | '/_protected/document-reader/'
    | '/_protected/lanes/'
    | '/_protected/org/$orgId/settings'
    | '/_protected/shipments/groups/$groupId'
    | '/_protected/shipments/(overview)/archived'
    | '/_protected/shipments/(overview)/assigned'
    | '/_protected/shipments/(overview)/drafted'
    | '/_protected/shipments/(overview)/groups'
    | '/_protected/shipments/add/bulk'
    | '/_protected/shipments/add/manual'
    | '/_protected/shipments/(overview)/'
    | '/_protected/shipments/add/'
    | '/_protected/org/$orgId/settings/documents'
    | '/_protected/org/$orgId/settings/users'
    | '/_protected/org/$orgId/settings/billing'
    | '/_protected/org/$orgId/settings/blacklisted-carriers'
    | '/_protected/org/$orgId/settings/shipment-settings'
    | '/_protected/org/$orgId/settings/subscriptions'
    | '/_protected/shipments/groups/$groupId/archived'
    | '/_protected/shipments/groups/$groupId/assigned'
    | '/_protected/shipments/groups/$groupId/drafted'
    | '/_protected/org/$orgId/settings/'
    | '/_protected/shipments/groups/$groupId/'
    | '/_protected/org/$orgId/settings/documents/'
    | '/_protected/org/$orgId/settings/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  ProtectedRouteRoute: typeof ProtectedRouteRouteWithChildren
  PublicPriceCalculatorChar123UuidChar125Route: typeof PublicPriceCalculatorChar123UuidChar125Route
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/sign-in': {
      id: '/_auth/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_protected/account': {
      id: '/_protected/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof ProtectedAccountRouteRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/carriers': {
      id: '/_protected/carriers'
      path: '/carriers'
      fullPath: '/carriers'
      preLoaderRoute: typeof ProtectedCarriersRouteRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/document-reader': {
      id: '/_protected/document-reader'
      path: '/document-reader'
      fullPath: '/document-reader'
      preLoaderRoute: typeof ProtectedDocumentReaderRouteRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/insights': {
      id: '/_protected/insights'
      path: '/insights'
      fullPath: '/insights'
      preLoaderRoute: typeof ProtectedInsightsRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/invoices': {
      id: '/_protected/invoices'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof ProtectedInvoicesRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/search': {
      id: '/_protected/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof ProtectedSearchRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/shipments': {
      id: '/_protected/shipments'
      path: '/shipments'
      fullPath: '/shipments'
      preLoaderRoute: typeof ProtectedShipmentsRouteRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/account/': {
      id: '/_protected/account/'
      path: '/'
      fullPath: '/account/'
      preLoaderRoute: typeof ProtectedAccountIndexRouteImport
      parentRoute: typeof ProtectedAccountRouteRoute
    }
    '/_protected/account/notifications': {
      id: '/_protected/account/notifications'
      path: '/notifications'
      fullPath: '/account/notifications'
      preLoaderRoute: typeof ProtectedAccountNotificationsRouteImport
      parentRoute: typeof ProtectedAccountRouteRoute
    }
    '/_protected/calculator/subscriptions': {
      id: '/_protected/calculator/subscriptions'
      path: '/calculator/subscriptions'
      fullPath: '/calculator/subscriptions'
      preLoaderRoute: typeof ProtectedCalculatorSubscriptionsRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/calculator/{-$uuid}': {
      id: '/_protected/calculator/{-$uuid}'
      path: '/calculator/{-$uuid}'
      fullPath: '/calculator/{-$uuid}'
      preLoaderRoute: typeof ProtectedCalculatorChar123UuidChar125RouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/carriers/': {
      id: '/_protected/carriers/'
      path: '/'
      fullPath: '/carriers/'
      preLoaderRoute: typeof ProtectedCarriersIndexRouteImport
      parentRoute: typeof ProtectedCarriersRouteRoute
    }
    '/_protected/carriers/add': {
      id: '/_protected/carriers/add'
      path: '/add'
      fullPath: '/carriers/add'
      preLoaderRoute: typeof ProtectedCarriersAddRouteImport
      parentRoute: typeof ProtectedCarriersRouteRoute
    }
    '/_protected/document-reader/': {
      id: '/_protected/document-reader/'
      path: '/'
      fullPath: '/document-reader/'
      preLoaderRoute: typeof ProtectedDocumentReaderIndexRouteImport
      parentRoute: typeof ProtectedDocumentReaderRouteRoute
    }
    '/_protected/document-reader/$submissionId': {
      id: '/_protected/document-reader/$submissionId'
      path: '/$submissionId'
      fullPath: '/document-reader/$submissionId'
      preLoaderRoute: typeof ProtectedDocumentReaderSubmissionIdRouteImport
      parentRoute: typeof ProtectedDocumentReaderRouteRoute
    }
    '/_protected/lanes/': {
      id: '/_protected/lanes/'
      path: '/lanes'
      fullPath: '/lanes/'
      preLoaderRoute: typeof ProtectedLanesIndexRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/lanes/$laneId': {
      id: '/_protected/lanes/$laneId'
      path: '/lanes/$laneId'
      fullPath: '/lanes/$laneId'
      preLoaderRoute: typeof ProtectedLanesLaneIdRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/lanes/create': {
      id: '/_protected/lanes/create'
      path: '/lanes/create'
      fullPath: '/lanes/create'
      preLoaderRoute: typeof ProtectedLanesCreateRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/shipments/$shipmentNumber': {
      id: '/_protected/shipments/$shipmentNumber'
      path: '/$shipmentNumber'
      fullPath: '/shipments/$shipmentNumber'
      preLoaderRoute: typeof ProtectedShipmentsShipmentNumberRouteImport
      parentRoute: typeof ProtectedShipmentsRouteRoute
    }
    '/_protected/shipments/(overview)': {
      id: '/_protected/shipments/(overview)'
      path: ''
      fullPath: '/shipments'
      preLoaderRoute: typeof ProtectedShipmentsoverviewRouteRouteImport
      parentRoute: typeof ProtectedShipmentsRouteRoute
    }
    '/_public/price-calculator/{-$uuid}': {
      id: '/_public/price-calculator/{-$uuid}'
      path: '/price-calculator/{-$uuid}'
      fullPath: '/price-calculator/{-$uuid}'
      preLoaderRoute: typeof PublicPriceCalculatorChar123UuidChar125RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected/org/$orgId/settings': {
      id: '/_protected/org/$orgId/settings'
      path: '/org/$orgId/settings'
      fullPath: '/org/$orgId/settings'
      preLoaderRoute: typeof ProtectedOrgOrgIdSettingsRouteRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/shipments/(overview)/': {
      id: '/_protected/shipments/(overview)/'
      path: '/'
      fullPath: '/shipments/'
      preLoaderRoute: typeof ProtectedShipmentsoverviewIndexRouteImport
      parentRoute: typeof ProtectedShipmentsoverviewRouteRoute
    }
    '/_protected/shipments/(overview)/archived': {
      id: '/_protected/shipments/(overview)/archived'
      path: '/archived'
      fullPath: '/shipments/archived'
      preLoaderRoute: typeof ProtectedShipmentsoverviewArchivedRouteImport
      parentRoute: typeof ProtectedShipmentsoverviewRouteRoute
    }
    '/_protected/shipments/(overview)/assigned': {
      id: '/_protected/shipments/(overview)/assigned'
      path: '/assigned'
      fullPath: '/shipments/assigned'
      preLoaderRoute: typeof ProtectedShipmentsoverviewAssignedRouteImport
      parentRoute: typeof ProtectedShipmentsoverviewRouteRoute
    }
    '/_protected/shipments/(overview)/drafted': {
      id: '/_protected/shipments/(overview)/drafted'
      path: '/drafted'
      fullPath: '/shipments/drafted'
      preLoaderRoute: typeof ProtectedShipmentsoverviewDraftedRouteImport
      parentRoute: typeof ProtectedShipmentsoverviewRouteRoute
    }
    '/_protected/shipments/(overview)/groups': {
      id: '/_protected/shipments/(overview)/groups'
      path: '/groups'
      fullPath: '/shipments/groups'
      preLoaderRoute: typeof ProtectedShipmentsoverviewGroupsRouteImport
      parentRoute: typeof ProtectedShipmentsoverviewRouteRoute
    }
    '/_protected/shipments/add/': {
      id: '/_protected/shipments/add/'
      path: '/add'
      fullPath: '/shipments/add/'
      preLoaderRoute: typeof ProtectedShipmentsAddIndexRouteImport
      parentRoute: typeof ProtectedShipmentsRouteRoute
    }
    '/_protected/shipments/add/bulk': {
      id: '/_protected/shipments/add/bulk'
      path: '/add/bulk'
      fullPath: '/shipments/add/bulk'
      preLoaderRoute: typeof ProtectedShipmentsAddBulkRouteImport
      parentRoute: typeof ProtectedShipmentsRouteRoute
    }
    '/_protected/shipments/add/manual': {
      id: '/_protected/shipments/add/manual'
      path: '/add/manual'
      fullPath: '/shipments/add/manual'
      preLoaderRoute: typeof ProtectedShipmentsAddManualRouteImport
      parentRoute: typeof ProtectedShipmentsRouteRoute
    }
    '/_protected/shipments/groups/$groupId': {
      id: '/_protected/shipments/groups/$groupId'
      path: '/groups/$groupId'
      fullPath: '/shipments/groups/$groupId'
      preLoaderRoute: typeof ProtectedShipmentsGroupsGroupIdRouteRouteImport
      parentRoute: typeof ProtectedShipmentsRouteRoute
    }
    '/_protected/org/$orgId/settings/': {
      id: '/_protected/org/$orgId/settings/'
      path: '/'
      fullPath: '/org/$orgId/settings/'
      preLoaderRoute: typeof ProtectedOrgOrgIdSettingsIndexRouteImport
      parentRoute: typeof ProtectedOrgOrgIdSettingsRouteRoute
    }
    '/_protected/org/$orgId/settings/billing': {
      id: '/_protected/org/$orgId/settings/billing'
      path: '/billing'
      fullPath: '/org/$orgId/settings/billing'
      preLoaderRoute: typeof ProtectedOrgOrgIdSettingsBillingRouteImport
      parentRoute: typeof ProtectedOrgOrgIdSettingsRouteRoute
    }
    '/_protected/org/$orgId/settings/blacklisted-carriers': {
      id: '/_protected/org/$orgId/settings/blacklisted-carriers'
      path: '/blacklisted-carriers'
      fullPath: '/org/$orgId/settings/blacklisted-carriers'
      preLoaderRoute: typeof ProtectedOrgOrgIdSettingsBlacklistedCarriersRouteImport
      parentRoute: typeof ProtectedOrgOrgIdSettingsRouteRoute
    }
    '/_protected/org/$orgId/settings/documents': {
      id: '/_protected/org/$orgId/settings/documents'
      path: '/documents'
      fullPath: '/org/$orgId/settings/documents'
      preLoaderRoute: typeof ProtectedOrgOrgIdSettingsDocumentsRouteRouteImport
      parentRoute: typeof ProtectedOrgOrgIdSettingsRouteRoute
    }
    '/_protected/org/$orgId/settings/shipment-settings': {
      id: '/_protected/org/$orgId/settings/shipment-settings'
      path: '/shipment-settings'
      fullPath: '/org/$orgId/settings/shipment-settings'
      preLoaderRoute: typeof ProtectedOrgOrgIdSettingsShipmentSettingsRouteImport
      parentRoute: typeof ProtectedOrgOrgIdSettingsRouteRoute
    }
    '/_protected/org/$orgId/settings/subscriptions': {
      id: '/_protected/org/$orgId/settings/subscriptions'
      path: '/subscriptions'
      fullPath: '/org/$orgId/settings/subscriptions'
      preLoaderRoute: typeof ProtectedOrgOrgIdSettingsSubscriptionsRouteImport
      parentRoute: typeof ProtectedOrgOrgIdSettingsRouteRoute
    }
    '/_protected/org/$orgId/settings/users': {
      id: '/_protected/org/$orgId/settings/users'
      path: '/users'
      fullPath: '/org/$orgId/settings/users'
      preLoaderRoute: typeof ProtectedOrgOrgIdSettingsUsersRouteRouteImport
      parentRoute: typeof ProtectedOrgOrgIdSettingsRouteRoute
    }
    '/_protected/shipments/groups/$groupId/': {
      id: '/_protected/shipments/groups/$groupId/'
      path: '/'
      fullPath: '/shipments/groups/$groupId/'
      preLoaderRoute: typeof ProtectedShipmentsGroupsGroupIdIndexRouteImport
      parentRoute: typeof ProtectedShipmentsGroupsGroupIdRouteRoute
    }
    '/_protected/shipments/groups/$groupId/archived': {
      id: '/_protected/shipments/groups/$groupId/archived'
      path: '/archived'
      fullPath: '/shipments/groups/$groupId/archived'
      preLoaderRoute: typeof ProtectedShipmentsGroupsGroupIdArchivedRouteImport
      parentRoute: typeof ProtectedShipmentsGroupsGroupIdRouteRoute
    }
    '/_protected/shipments/groups/$groupId/assigned': {
      id: '/_protected/shipments/groups/$groupId/assigned'
      path: '/assigned'
      fullPath: '/shipments/groups/$groupId/assigned'
      preLoaderRoute: typeof ProtectedShipmentsGroupsGroupIdAssignedRouteImport
      parentRoute: typeof ProtectedShipmentsGroupsGroupIdRouteRoute
    }
    '/_protected/shipments/groups/$groupId/drafted': {
      id: '/_protected/shipments/groups/$groupId/drafted'
      path: '/drafted'
      fullPath: '/shipments/groups/$groupId/drafted'
      preLoaderRoute: typeof ProtectedShipmentsGroupsGroupIdDraftedRouteImport
      parentRoute: typeof ProtectedShipmentsGroupsGroupIdRouteRoute
    }
    '/_protected/org/$orgId/settings/documents/': {
      id: '/_protected/org/$orgId/settings/documents/'
      path: '/'
      fullPath: '/org/$orgId/settings/documents/'
      preLoaderRoute: typeof ProtectedOrgOrgIdSettingsDocumentsIndexRouteImport
      parentRoute: typeof ProtectedOrgOrgIdSettingsDocumentsRouteRoute
    }
    '/_protected/org/$orgId/settings/users/': {
      id: '/_protected/org/$orgId/settings/users/'
      path: '/'
      fullPath: '/org/$orgId/settings/users/'
      preLoaderRoute: typeof ProtectedOrgOrgIdSettingsUsersIndexRouteImport
      parentRoute: typeof ProtectedOrgOrgIdSettingsUsersRouteRoute
    }
  }
}

interface AuthRouteRouteChildren {
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignInRoute: typeof AuthSignInRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignInRoute: AuthSignInRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface ProtectedAccountRouteRouteChildren {
  ProtectedAccountNotificationsRoute: typeof ProtectedAccountNotificationsRoute
  ProtectedAccountIndexRoute: typeof ProtectedAccountIndexRoute
}

const ProtectedAccountRouteRouteChildren: ProtectedAccountRouteRouteChildren = {
  ProtectedAccountNotificationsRoute: ProtectedAccountNotificationsRoute,
  ProtectedAccountIndexRoute: ProtectedAccountIndexRoute,
}

const ProtectedAccountRouteRouteWithChildren =
  ProtectedAccountRouteRoute._addFileChildren(
    ProtectedAccountRouteRouteChildren,
  )

interface ProtectedCarriersRouteRouteChildren {
  ProtectedCarriersAddRoute: typeof ProtectedCarriersAddRoute
  ProtectedCarriersIndexRoute: typeof ProtectedCarriersIndexRoute
}

const ProtectedCarriersRouteRouteChildren: ProtectedCarriersRouteRouteChildren =
  {
    ProtectedCarriersAddRoute: ProtectedCarriersAddRoute,
    ProtectedCarriersIndexRoute: ProtectedCarriersIndexRoute,
  }

const ProtectedCarriersRouteRouteWithChildren =
  ProtectedCarriersRouteRoute._addFileChildren(
    ProtectedCarriersRouteRouteChildren,
  )

interface ProtectedDocumentReaderRouteRouteChildren {
  ProtectedDocumentReaderSubmissionIdRoute: typeof ProtectedDocumentReaderSubmissionIdRoute
  ProtectedDocumentReaderIndexRoute: typeof ProtectedDocumentReaderIndexRoute
}

const ProtectedDocumentReaderRouteRouteChildren: ProtectedDocumentReaderRouteRouteChildren =
  {
    ProtectedDocumentReaderSubmissionIdRoute:
      ProtectedDocumentReaderSubmissionIdRoute,
    ProtectedDocumentReaderIndexRoute: ProtectedDocumentReaderIndexRoute,
  }

const ProtectedDocumentReaderRouteRouteWithChildren =
  ProtectedDocumentReaderRouteRoute._addFileChildren(
    ProtectedDocumentReaderRouteRouteChildren,
  )

interface ProtectedShipmentsoverviewRouteRouteChildren {
  ProtectedShipmentsoverviewArchivedRoute: typeof ProtectedShipmentsoverviewArchivedRoute
  ProtectedShipmentsoverviewAssignedRoute: typeof ProtectedShipmentsoverviewAssignedRoute
  ProtectedShipmentsoverviewDraftedRoute: typeof ProtectedShipmentsoverviewDraftedRoute
  ProtectedShipmentsoverviewGroupsRoute: typeof ProtectedShipmentsoverviewGroupsRoute
  ProtectedShipmentsoverviewIndexRoute: typeof ProtectedShipmentsoverviewIndexRoute
}

const ProtectedShipmentsoverviewRouteRouteChildren: ProtectedShipmentsoverviewRouteRouteChildren =
  {
    ProtectedShipmentsoverviewArchivedRoute:
      ProtectedShipmentsoverviewArchivedRoute,
    ProtectedShipmentsoverviewAssignedRoute:
      ProtectedShipmentsoverviewAssignedRoute,
    ProtectedShipmentsoverviewDraftedRoute:
      ProtectedShipmentsoverviewDraftedRoute,
    ProtectedShipmentsoverviewGroupsRoute:
      ProtectedShipmentsoverviewGroupsRoute,
    ProtectedShipmentsoverviewIndexRoute: ProtectedShipmentsoverviewIndexRoute,
  }

const ProtectedShipmentsoverviewRouteRouteWithChildren =
  ProtectedShipmentsoverviewRouteRoute._addFileChildren(
    ProtectedShipmentsoverviewRouteRouteChildren,
  )

interface ProtectedShipmentsGroupsGroupIdRouteRouteChildren {
  ProtectedShipmentsGroupsGroupIdArchivedRoute: typeof ProtectedShipmentsGroupsGroupIdArchivedRoute
  ProtectedShipmentsGroupsGroupIdAssignedRoute: typeof ProtectedShipmentsGroupsGroupIdAssignedRoute
  ProtectedShipmentsGroupsGroupIdDraftedRoute: typeof ProtectedShipmentsGroupsGroupIdDraftedRoute
  ProtectedShipmentsGroupsGroupIdIndexRoute: typeof ProtectedShipmentsGroupsGroupIdIndexRoute
}

const ProtectedShipmentsGroupsGroupIdRouteRouteChildren: ProtectedShipmentsGroupsGroupIdRouteRouteChildren =
  {
    ProtectedShipmentsGroupsGroupIdArchivedRoute:
      ProtectedShipmentsGroupsGroupIdArchivedRoute,
    ProtectedShipmentsGroupsGroupIdAssignedRoute:
      ProtectedShipmentsGroupsGroupIdAssignedRoute,
    ProtectedShipmentsGroupsGroupIdDraftedRoute:
      ProtectedShipmentsGroupsGroupIdDraftedRoute,
    ProtectedShipmentsGroupsGroupIdIndexRoute:
      ProtectedShipmentsGroupsGroupIdIndexRoute,
  }

const ProtectedShipmentsGroupsGroupIdRouteRouteWithChildren =
  ProtectedShipmentsGroupsGroupIdRouteRoute._addFileChildren(
    ProtectedShipmentsGroupsGroupIdRouteRouteChildren,
  )

interface ProtectedShipmentsRouteRouteChildren {
  ProtectedShipmentsoverviewRouteRoute: typeof ProtectedShipmentsoverviewRouteRouteWithChildren
  ProtectedShipmentsShipmentNumberRoute: typeof ProtectedShipmentsShipmentNumberRoute
  ProtectedShipmentsGroupsGroupIdRouteRoute: typeof ProtectedShipmentsGroupsGroupIdRouteRouteWithChildren
  ProtectedShipmentsAddBulkRoute: typeof ProtectedShipmentsAddBulkRoute
  ProtectedShipmentsAddManualRoute: typeof ProtectedShipmentsAddManualRoute
  ProtectedShipmentsAddIndexRoute: typeof ProtectedShipmentsAddIndexRoute
}

const ProtectedShipmentsRouteRouteChildren: ProtectedShipmentsRouteRouteChildren =
  {
    ProtectedShipmentsoverviewRouteRoute:
      ProtectedShipmentsoverviewRouteRouteWithChildren,
    ProtectedShipmentsShipmentNumberRoute:
      ProtectedShipmentsShipmentNumberRoute,
    ProtectedShipmentsGroupsGroupIdRouteRoute:
      ProtectedShipmentsGroupsGroupIdRouteRouteWithChildren,
    ProtectedShipmentsAddBulkRoute: ProtectedShipmentsAddBulkRoute,
    ProtectedShipmentsAddManualRoute: ProtectedShipmentsAddManualRoute,
    ProtectedShipmentsAddIndexRoute: ProtectedShipmentsAddIndexRoute,
  }

const ProtectedShipmentsRouteRouteWithChildren =
  ProtectedShipmentsRouteRoute._addFileChildren(
    ProtectedShipmentsRouteRouteChildren,
  )

interface ProtectedOrgOrgIdSettingsDocumentsRouteRouteChildren {
  ProtectedOrgOrgIdSettingsDocumentsIndexRoute: typeof ProtectedOrgOrgIdSettingsDocumentsIndexRoute
}

const ProtectedOrgOrgIdSettingsDocumentsRouteRouteChildren: ProtectedOrgOrgIdSettingsDocumentsRouteRouteChildren =
  {
    ProtectedOrgOrgIdSettingsDocumentsIndexRoute:
      ProtectedOrgOrgIdSettingsDocumentsIndexRoute,
  }

const ProtectedOrgOrgIdSettingsDocumentsRouteRouteWithChildren =
  ProtectedOrgOrgIdSettingsDocumentsRouteRoute._addFileChildren(
    ProtectedOrgOrgIdSettingsDocumentsRouteRouteChildren,
  )

interface ProtectedOrgOrgIdSettingsUsersRouteRouteChildren {
  ProtectedOrgOrgIdSettingsUsersIndexRoute: typeof ProtectedOrgOrgIdSettingsUsersIndexRoute
}

const ProtectedOrgOrgIdSettingsUsersRouteRouteChildren: ProtectedOrgOrgIdSettingsUsersRouteRouteChildren =
  {
    ProtectedOrgOrgIdSettingsUsersIndexRoute:
      ProtectedOrgOrgIdSettingsUsersIndexRoute,
  }

const ProtectedOrgOrgIdSettingsUsersRouteRouteWithChildren =
  ProtectedOrgOrgIdSettingsUsersRouteRoute._addFileChildren(
    ProtectedOrgOrgIdSettingsUsersRouteRouteChildren,
  )

interface ProtectedOrgOrgIdSettingsRouteRouteChildren {
  ProtectedOrgOrgIdSettingsDocumentsRouteRoute: typeof ProtectedOrgOrgIdSettingsDocumentsRouteRouteWithChildren
  ProtectedOrgOrgIdSettingsUsersRouteRoute: typeof ProtectedOrgOrgIdSettingsUsersRouteRouteWithChildren
  ProtectedOrgOrgIdSettingsBillingRoute: typeof ProtectedOrgOrgIdSettingsBillingRoute
  ProtectedOrgOrgIdSettingsBlacklistedCarriersRoute: typeof ProtectedOrgOrgIdSettingsBlacklistedCarriersRoute
  ProtectedOrgOrgIdSettingsShipmentSettingsRoute: typeof ProtectedOrgOrgIdSettingsShipmentSettingsRoute
  ProtectedOrgOrgIdSettingsSubscriptionsRoute: typeof ProtectedOrgOrgIdSettingsSubscriptionsRoute
  ProtectedOrgOrgIdSettingsIndexRoute: typeof ProtectedOrgOrgIdSettingsIndexRoute
}

const ProtectedOrgOrgIdSettingsRouteRouteChildren: ProtectedOrgOrgIdSettingsRouteRouteChildren =
  {
    ProtectedOrgOrgIdSettingsDocumentsRouteRoute:
      ProtectedOrgOrgIdSettingsDocumentsRouteRouteWithChildren,
    ProtectedOrgOrgIdSettingsUsersRouteRoute:
      ProtectedOrgOrgIdSettingsUsersRouteRouteWithChildren,
    ProtectedOrgOrgIdSettingsBillingRoute:
      ProtectedOrgOrgIdSettingsBillingRoute,
    ProtectedOrgOrgIdSettingsBlacklistedCarriersRoute:
      ProtectedOrgOrgIdSettingsBlacklistedCarriersRoute,
    ProtectedOrgOrgIdSettingsShipmentSettingsRoute:
      ProtectedOrgOrgIdSettingsShipmentSettingsRoute,
    ProtectedOrgOrgIdSettingsSubscriptionsRoute:
      ProtectedOrgOrgIdSettingsSubscriptionsRoute,
    ProtectedOrgOrgIdSettingsIndexRoute: ProtectedOrgOrgIdSettingsIndexRoute,
  }

const ProtectedOrgOrgIdSettingsRouteRouteWithChildren =
  ProtectedOrgOrgIdSettingsRouteRoute._addFileChildren(
    ProtectedOrgOrgIdSettingsRouteRouteChildren,
  )

interface ProtectedRouteRouteChildren {
  ProtectedAccountRouteRoute: typeof ProtectedAccountRouteRouteWithChildren
  ProtectedCarriersRouteRoute: typeof ProtectedCarriersRouteRouteWithChildren
  ProtectedDocumentReaderRouteRoute: typeof ProtectedDocumentReaderRouteRouteWithChildren
  ProtectedShipmentsRouteRoute: typeof ProtectedShipmentsRouteRouteWithChildren
  ProtectedInsightsRoute: typeof ProtectedInsightsRoute
  ProtectedInvoicesRoute: typeof ProtectedInvoicesRoute
  ProtectedSearchRoute: typeof ProtectedSearchRoute
  ProtectedCalculatorSubscriptionsRoute: typeof ProtectedCalculatorSubscriptionsRoute
  ProtectedCalculatorChar123UuidChar125Route: typeof ProtectedCalculatorChar123UuidChar125Route
  ProtectedLanesLaneIdRoute: typeof ProtectedLanesLaneIdRoute
  ProtectedLanesCreateRoute: typeof ProtectedLanesCreateRoute
  ProtectedLanesIndexRoute: typeof ProtectedLanesIndexRoute
  ProtectedOrgOrgIdSettingsRouteRoute: typeof ProtectedOrgOrgIdSettingsRouteRouteWithChildren
}

const ProtectedRouteRouteChildren: ProtectedRouteRouteChildren = {
  ProtectedAccountRouteRoute: ProtectedAccountRouteRouteWithChildren,
  ProtectedCarriersRouteRoute: ProtectedCarriersRouteRouteWithChildren,
  ProtectedDocumentReaderRouteRoute:
    ProtectedDocumentReaderRouteRouteWithChildren,
  ProtectedShipmentsRouteRoute: ProtectedShipmentsRouteRouteWithChildren,
  ProtectedInsightsRoute: ProtectedInsightsRoute,
  ProtectedInvoicesRoute: ProtectedInvoicesRoute,
  ProtectedSearchRoute: ProtectedSearchRoute,
  ProtectedCalculatorSubscriptionsRoute: ProtectedCalculatorSubscriptionsRoute,
  ProtectedCalculatorChar123UuidChar125Route:
    ProtectedCalculatorChar123UuidChar125Route,
  ProtectedLanesLaneIdRoute: ProtectedLanesLaneIdRoute,
  ProtectedLanesCreateRoute: ProtectedLanesCreateRoute,
  ProtectedLanesIndexRoute: ProtectedLanesIndexRoute,
  ProtectedOrgOrgIdSettingsRouteRoute:
    ProtectedOrgOrgIdSettingsRouteRouteWithChildren,
}

const ProtectedRouteRouteWithChildren = ProtectedRouteRoute._addFileChildren(
  ProtectedRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  ProtectedRouteRoute: ProtectedRouteRouteWithChildren,
  PublicPriceCalculatorChar123UuidChar125Route:
    PublicPriceCalculatorChar123UuidChar125Route,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
